import { errorNotifier } from '@/utils/bugsnag';

export function logError(msg: string, host?: string) {
  const formattedMsg = `${msg} ${host ? `(url: ${host})` : ''}`;

  const error = new Error(formattedMsg);

  errorNotifier.notify(error, { host });

  console.error(formattedMsg);
}
